/**
 * Copyright © 2022 Anagog Ltd. All rights reserved.
 */

import {
  DeviceEventEmitter,
  NativeEventEmitter,
  NativeModules,
  Platform,
} from 'react-native';

// Event emitter for receiving commands from native code
export const eventEmitter = Platform.select({
  ios: new NativeEventEmitter(NativeModules.EventEmitter),
  android: DeviceEventEmitter,
});
